import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Input } from '../../../../../../../itrust_common/components/form'
import { required } from '../../../../../../../itrust_common/components/form/FormValidations'
import { connect, useDispatch } from 'react-redux'
import { SaveButton } from '../../../../../../../itrust_common/components/others'
import { tabAddonUpdate } from '../../../../../../../redux/actions/addOns/rpa/tab/tabAction'
import Alert from '../../../../../../../itrust_common/components/Alert'
import { useSelectStoreHook } from '../../../../other/useSelectStoreHook'

function TabCredForm(props) {
  const { handleSubmit, tabAddOnCred, saving, isPopUp, setTabPopUpStatus } = props
  const dispatch = useDispatch()
  useSelectStoreHook('/add-ons/tab/dashboard')

  const handleTabCredSubmit = async (data) => {
    if (localStorage.getItem('StoreID')) {
      await dispatch(tabAddonUpdate({ ...data }))
      setTabPopUpStatus && setTabPopUpStatus('close')
    }
    else {
      Alert.warning("Please select store from top dropdown.")
    }
  }

  return (
    <form onSubmit={handleSubmit(handleTabCredSubmit)}>
      <div className={`row mx-0 ${isPopUp ? '' : 'pt-7'}`}>
        <div className={`bg-white shadow px-0 ${isPopUp ? 'col-12' : 'col-10'}`}>
          <h6 className='border-bottom border-bottom-2 border-light p-5'>TAB Credentials</h6>
          <div className='w-100 mt-6 px-7'>
            <div className='row'>
              <Field name="config.creds.username" label="Username" placeholder='Enter your Username' component={Input} className="form-control" wrapperClasses={`form-group ${isPopUp ? 'col-12' : 'col-6'}`} validate={[required]} readOnly={tabAddOnCred?.status === 'success'} />
              <Field type='password' name="config.creds.password" label="Password" placeholder='Enter your Password' component={Input} className="form-control" wrapperClasses={`form-group ${isPopUp ? 'col-12' : 'col-6'}`} validate={[required]} readOnly={(tabAddOnCred?.status === 'pending' || tabAddOnCred?.status === 'success')} />
            </div>
          </div>
          {(tabAddOnCred?.username && tabAddOnCred?.status !== 'success') && <h5 className={`text-danger mx-7 my-5 ${isPopUp ? 'font-size-18' : ''}`}>{tabAddOnCred?.message}</h5>}
          <SaveButton saving={saving} label={`${(tabAddOnCred?.status && tabAddOnCred?.status == 'success') ? 'Update' : 'Login'}`} buttonClasses={`${isPopUp ? 'btn-sm' : ''}`} wrapperClasses={`mb-5 mr-7 d-flex justify-content-end mt-4 ${tabAddOnCred?.status === 'pending' && 'disabled'}`} />
        </div>
      </div>
    </form>
  )
}

TabCredForm = reduxForm({
  form: 'TabCredForm',
  enableReinitialize: true
})(TabCredForm)

const mapStateToProps = (state) => {
  const { tab } = state
  return {
    tabAddOnCred: tab.tab_add_on?.config?.creds,
    saving: tab.saving,
    initialValues: {
      ...tab.tab_add_on
    }
  }
}

export default connect(mapStateToProps)(TabCredForm)